/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Hub_GroupInputs */

const en_us2_clubs_hub_group = /** @type {(inputs: Clubs_Hub_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Together`)
};

const pt_br2_clubs_hub_group = /** @type {(inputs: Clubs_Hub_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juntos`)
};

const es_419_clubs_hub_group = /** @type {(inputs: Clubs_Hub_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juntos`)
};

const pt_pt2_clubs_hub_group = /** @type {(inputs: Clubs_Hub_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juntos`)
};

const fr_fr2_clubs_hub_group = /** @type {(inputs: Clubs_Hub_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ensemble`)
};

const de_de2_clubs_hub_group = /** @type {(inputs: Clubs_Hub_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gemeinsam`)
};

const it_it2_clubs_hub_group = /** @type {(inputs: Clubs_Hub_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insieme`)
};

/**
* | output |
* | --- |
* | "Together" |
*
* @param {Clubs_Hub_GroupInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_hub_group = /** @type {((inputs?: Clubs_Hub_GroupInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Hub_GroupInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_hub_group(inputs)
	if (locale === "es-419") return es_419_clubs_hub_group(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_hub_group(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_hub_group(inputs)
	if (locale === "de-DE") return de_de2_clubs_hub_group(inputs)
	if (locale === "it-IT") return it_it2_clubs_hub_group(inputs)
	return en_us2_clubs_hub_group(inputs)
});
export { clubs_hub_group as "clubs.hub_group" }